import { render, staticRenderFns } from "./PeopleView.vue?vue&type=template&id=175c3fe2&scoped=true&"
import script from "./PeopleView.vue?vue&type=script&setup=true&lang=js&"
export * from "./PeopleView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PeopleView.vue?vue&type=style&index=0&id=175c3fe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175c3fe2",
  null
  
)

export default component.exports